<!--  9.9支付抢购 -->
<template>
<div v-if="bodyShow">
  <div v-if="qrcodeShow" class="payback" :style="{'minHeight': clientHeight + 'px'}">
      <img src="https://misc.xjy.cn/accelerator/growth/20210420/success_v2.png" class="bg">
  </div>
  <div v-else class="rush-main">
      <div class="pb">
        <img  class="img1" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img1_v2.png" alt="" >
        <!-- form -->
        <div id="form"  class="rush-bg">
            <div class="rush-form">
                <h5>（已加密,请放心填写）</h5>
                <div class="row">
                    <input type="text" :class="(!phone && !bool)?'on':''" v-model="phone" :placeholder="(!phone && !bool)?'此项不能为空请输入':'请输入手机号码'" />
                </div>
                <div class="row">
                    <input type="text" :class="(!code && !bool)?'on':''" v-model="code" :placeholder="(!code && !bool)?'此项不能为空请输入':'请输入验证码'" />
                    <van-button size="small" type="warning" round @click="getCodeHandle" :disabled="!canClick">{{codeText}}</van-button>
                </div>
                <div class="xy" @click="checkBool=!checkBool">
                    <img v-if="!checkBool" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/check.png" alt="">
                    <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/checked.png" alt="">
                    自动输入历史手机号<span>《个人信息授权与保护声明》</span>
                </div>
                <a  @click="validatorHandle()" class="subBtn">限时9.9元&nbsp;&nbsp;&nbsp;立即报名</a>
                <p>温馨提示：支付成功后，需按提示添加老师微信，以免错失上课提醒实时答疑、测评礼包等专享服务</p>
            </div>
        </div>
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img3.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img4.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img5.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img6.png" alt="" >
        <!-- form -->
        <div class="rush-bg2">
            <div class="rush-form">
                <h5>（已加密,请放心填写）</h5>
                <div class="row">
                    <input type="text" :class="(!phone && !bool)?'on':''" v-model="phone" :placeholder="(!phone && !bool)?'此项不能为空请输入':'请输入手机号码'" />
                </div>
                <div class="row">
                    <input type="text" :class="(!code && !bool)?'on':''" v-model="code" :placeholder="(!code && !bool)?'此项不能为空请输入':'请输入验证码'" />
                    <van-button size="small" type="warning" round @click="getCodeHandle" :disabled="!canClick">{{codeText}}</van-button>
                </div>
                <div class="xy" @click="checkBool=!checkBool">
                    <img v-if="!checkBool" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/check.png" alt="">
                    <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/checked.png" alt="">
                    自动输入历史手机号<span>《个人信息授权与保护声明》</span>
                </div>
                <a  @click="validatorHandle()" class="subBtn">限时9.9元&nbsp;&nbsp;&nbsp;立即报名</a>
                <p>温馨提示：支付成功后，需按提示添加老师微信，以免错失上课提醒实时答疑、测评礼包等专享服务</p>
            </div>
        </div>
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img8.png" alt="" >
      </div>
      <div class="media-rush">
        <img class="media-rush-img" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/bottom2.png">
        <img @click="setScrollTo()" class="media-rush-btn" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/btn.png">
        <div class="timer-box xh">{{hour}}</div>
        <div class="timer-box xm">{{minute}}</div>
        <div class="timer-box xs">{{second}}</div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { wxpay,h5wxpay,orders,checkpay,toutiao_track,check_phone,baidu_track,qq_track } from "@/api/other";
import { getStorage, setStorage, deepCopy,deleteStorage, isWeixin,queryString,delParam,isMain } from "@/utils/tools";
import { phoneValidation,events } from "@/utils/validation";
// import {Dialog} from 'vant';
export default {
    data(){
        return{
            data:{},
            bodyShow:false,
            checkBool:false,
            name:'',
            phone:null,
            bool:true,
            qrcodeShow:false,
            qrType:'',
            isBuy: false,
            clientHeight: 1334,
            hour: '00',
            minute: '10',
            second: '00',
            time_in_sec: 600,
            timer: null,
            buy_id: 5,
            sms_id: null,
            code: null,
            codeText: '发送验证码',
            time: 60,
            canClick: true,
            retry: 4,
            Url: isMain() ? 'https://open.xjy.cn/api' : 'https://open.xjy.cn/dev'
        }
    },
    mounted(){
        this.clientHeight = document.documentElement.clientHeight;
        this.timer = setInterval(()=>{
            if(this.time_in_sec > 0) {
                this.time_in_sec--;
                
                let second = this.time_in_sec;
                let hour = Math.floor(second / 3600);
                second -= 3600 * hour;
                let minute = Math.floor(second / 60);
                second -= 60 * minute;

                this.hour = hour >= 10 ? hour + '' : '0' + hour;
                this.minute = minute >= 10 ? minute + '' : '0' + minute;
                this.second = second >= 10 ? second + '' : '0' + second;
            } else {
                clearInterval(this.timer);
            }
        }, 1000);
    },
    methods:{
        // 滚动到指定位置
        setScrollTo(){
            var el=document.getElementById('form');
            this.$nextTick(function () {
                window.scrollTo({"behavior":"smooth","top":el.offsetTop});
            })
        },
        checkCodeHandle(){
            let self = this;

            if(!self.sms_id) {
                self.$toast('请发送验证码');
                return;
            }
            
            if(!self.code) {
                self.$toast('请输入验证码');
                return;
            }

            // 验证验证码是否正确
            let params = new URLSearchParams();
            params.append('code', self.code);
            params.append('sms_id', self.sms_id);
            axios.post(self.Url+'/cms/check_sms', params).then(success=>{
                if(success.data.error != 0){
                    self.$toast(success.data.msg);
                    return;
                }
                function send_crm() {
                    let params = new URLSearchParams();
                    params.append('phone', self.phone);
                    params.append('source', "9.9转化营2");
                    params.append('name', self.name);
                    axios.post(self.$Url+'crm/', params).then(success=>{
                        if(success.status!=200){
                            self.$toast(success.statusText);
                            return
                        }
                        if(success.data.status==1){
                            self.$toast('提交成功！');
                        }
                    });

                    self.baiduHandle();
                    self.toutiaoHandle();
                    self.qqHandle();
                    
                    self.payHandle();
                }

                window.onOK = function() {
                    send_crm();
                }

                window.onError = function() {
                    send_crm();
                }

                if(typeof sendPage == 'function') {
                    sendPage(self.phone, self.name);
                } else {
                    send_crm();
                }
            });
        },
        // 获取验证码
        getCodeHandle(){
            // 验证手机号是否正确
            if(!phoneValidation(this.phone)){
                this.$toast('请输入正确的手机号！');
                return
            }
            // 倒计时
            events(this.codeText, this.time, this.canClick, (codeText, time, canClick) => {
                this.codeText = codeText;
                this.time = time;
                this.canClick = canClick;
            });

            if(this.canClick){
                let params = new URLSearchParams();
                params.append('mobile', this.phone);
                axios.post(this.Url+'/cms/send_sms', params).then(success=>{
                    if(success.data.error != 0){
                        self.$toast(success.data.msg);
                        return
                    }else{
                        this.sms_id = success.data.sms_id;
                    }
                });
            }
        },
        // 验证信息
        validatorHandle(){
            let self = this;

            if(!self.phone){
                self.$toast('手机号不能为空！');
                self.bool = false;
                return
            }
            if(!phoneValidation(self.phone)){
                self.$toast('请输入正确的手机号！');
                return
            }
            if(!self.checkBool){
                self.$toast('请先同意《个人信息授权与保护声明》！');
                return
            }
            if(self.checkBool){
                setStorage(self.$route.path, 'userObj', {
                    name:self.name,
                    phone:self.phone,
                    checkBool:self.checkBool
                });
            }else{
                deleteStorage(self.$route.path);
            }
            // 验证是否存在手机号
            check_phone({
                phone:self.phone
            }).then(res=>{
                if (res.code == 10002) {
                    self.$toast(res.data.msg);
                    return ;
                }
                if(res.exist && isMain()){
                    self.$toast('本课程仅限新精英新用户领取！');
                    return ;
                }

                self.checkCodeHandle();
            });

        },
        // 百度统计请求
        baiduHandle(){
            baidu_track({
                conversionTypes:[ {
                    "logidUrl": window.location.href,
                    "newType": 3
                }]
            }).then(res=>{
                
            });
        },
        toutiaoHandle(){     
            toutiao_track({
                referer: window.location.href
            }).then(data=>{
            });
        },
        qqHandle(){
            let click_id = this.$route.query.qz_gdt || this.$route.query.gdt_vid;
            if(!click_id) {
                return false;
            }

            qq_track({
                actions: [
                    {
                        url: window.location.href,
                        action_time: Math.floor((new Date()).getTime() / 1000),
                        action_type: 'RESERVATION',
                        trace: {
                            click_id: click_id
                        }
                    }
                ]
            }).then(data=>{
            });
        },
        payHandle() {
            //调用加载中
            this.$emit('loadingHandle',true,"支付加载中...");

            if(isWeixin()) {
                wxpay({
                   name:this.name,
                   phone:this.phone,
                   referer:window.location.href,
                   buy_id: this.buy_id
                }).then(data => {
                    let data_ = eval("(" + data.jsApiParameters + ")");
                    let jsApiCall = () => {
                        WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
                            //关闭加载中
                            this.$emit('loadingHandle',false);
                            WeixinJSBridge.log(rest.err_msg);
                            if (rest.err_msg == "get_brand_wcpay_request:ok") {
                                this.$toast('支付成功');
                                // this.$router.push('/rush_purchase_success');
                                this.qrcodeShow = true;
                            } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                                alert("支付取消");
                            } else {
                                alert("支付失败");
                            }
                        });
                    };

                    if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
                    } else if (document.attachEvent) {
                        document.attachEvent("WeixinJSBridgeReady", jsApiCall);
                        document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
                    }
                    } else {
                        jsApiCall();
                    }
                });
            } else {
                h5wxpay({
                   name:this.name,
                   phone:this.phone,
                   referer:window.location.href,
                   buy_id: this.buy_id
                }).then(data => {
                    let mweb_url = data.h5Parameters.mweb_url;
                    let trade_no = data.h5Parameters.trade_no;

                    // 缓存trade_no 用于查询订单是否支付成功
                    setStorage(this.$route.path, 'trade_no',trade_no)
                    let seperator = window.location.href.indexOf('?') > 0 ? '&' : '?';
                    let page_url = encodeURIComponent(window.location.href.replace(/[&\?]trade_no=[^&]+/g, '') + seperator + 'trade_no=' + trade_no);
                    window.location.href = `${mweb_url}&redirect_url=${page_url}`;
                });
                
            }
            
        },
        pullData(onNotPaid, onPaid){
            if(isWeixin()) {
                orders({
                    buy_id: this.buy_id
                }).then((data)=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    this.data = data;
                    this.qrType = this.$route.query.sou;
                    document.title = "7天职业发展特训营";
                    if(data.orders.length>0){
                        if(onPaid) {
                            onPaid();
                        }
                        this.isBuy = true;
                        this.qrcodeShow = true;
                        this.bodyShow = true;
                        // this.$router.push('/rush_purchase_success');
                        return
                    } else if (onNotPaid) {
                        if(onNotPaid()){
                            return;
                        }
                    }
                    
                    this.bodyShow = true;
                    
                    let obj = getStorage(this.$route.path, 'userObj');
                    if(obj && String(obj)!='{}'){
                        this.name = obj.name;
                        this.phone = obj.phone;
                        this.checkBool = obj.checkBool;
                    }
                });
            } else {
                //  || 
                let trade_no =queryString(location.href,'trade_no')?queryString(location.href,'trade_no'):getStorage(this.$route.path, 'trade_no');

                checkpay({
                    trade_no: trade_no
                }).then((data=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    this.data = data;
                    this.qrType = this.$route.query.sou;
                    document.title = "7天职业发展特训营";
                    if(data.is_buy){
                        if(onPaid) {
                            onPaid();
                        }

                        this.isBuy = true;
                        this.qrcodeShow = true;
                        this.bodyShow = true;
                        // this.$router.push('/rush_purchase_success');
                        return
                    } else if (onNotPaid) {
                        if(onNotPaid()){
                            return;
                        }
                    }
                    
                    this.bodyShow = true;
                    let obj = getStorage(this.$route.path, 'userObj');
                    if(obj && String(obj)!='{}'){
                        this.name = obj.name;
                        this.phone = obj.phone;
                        this.checkBool = obj.checkBool;
                    }
                }));
            }
            
        },
        addScript: function() {
            let jquery_url = 'https://statics-cdn.xjy.cn/js/jquery-2.1.4.min.js';

            if(!window.jQuery) {
                let script1 = document.createElement('script');
                script1.type = 'text/javascript';
                script1.src = jquery_url;
                document.getElementsByTagName('head')[0].appendChild(script1);
            }


            let mantis_url = ['ff1','ff2'].indexOf(this.$route.query.sou) > - 1 ? 'https://chatn9.bjmantis.net/chat/js/dist/mantis.min.js?6375#5f1666f730b02403751e31fc' : 'https://chatn9.bjmantis.net/chat/js/dist/mantis.min.js?6375#5f16670ba95cf511bc056a34';

            if(!window.mantis) {
                let script2 = document.createElement('script');
                script2.type = 'text/javascript';
                script2.src = mantis_url;
                document.getElementsByTagName('head')[0].appendChild(script2);
            }
        },
    },
    created(){
        document.title = "7天职业发展特训营";

        this.addScript();
        let trade_no =queryString(location.href,'trade_no')?queryString(location.href,'trade_no'):getStorage(this.$route.path, 'trade_no');
        if(trade_no === 'true') {
            this.qrcodeShow = true;
            this.bodyShow = true;
        } else if(queryString(location.href,'trade_no')){
            //调用加载中
            this.$emit('loadingHandle',true,"支付结果查询中...");
            let onPaid = () => {
                this.$emit('loadingHandle',false);
            }
            let onNotPaid = () => {
                if(this.retry>0) {
                    this.retry--;
                    setTimeout(()=>{
                        this.pullData(onNotPaid, onPaid);
                    }, 1000);
                    return true;
                } else {
                    this.$emit('loadingHandle',false);
                    return false;
                }
            }
            this.pullData(onNotPaid, onPaid);
        }else{
            this.pullData();
        }
    }
}
</script>

<style lang="scss" scoped>
.row {
    position: relative;

    button {
        position: absolute;
        top: 50%;
        right: 80px;
        transform: translateY(-50%);
        margin-top: -10px;
        padding: 0 20px;
        font-size: 26px;
    }
}
.payback {
    width: 100%;
    background: #0496FC;

    .bg {
        width: 100%;
        vertical-align: bottom;
    }
}
.media-rush{
    position: fixed;
    width: 750px;
    max-width: 750px;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 888;
    .media-rush-img{
        width: 750px;
        height: 120px;
        position: relative;
    }
    .timer-box {
        width: 41px;
        height: 41px;
        line-height: 45px;
        font-family: Arial,sans-serif;
        font-size: 26px;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 45px;
    }
    .xh {
        left: 364px;
    }
    .xm {
        left: 420px;
    }
    .xs {
        left: 476px;
    }
    
    @keyframes mymove{
        0%{
            transform: scale(1);  /*开始为原始大小*/
        }
        25%{
            transform: scale(1.1); /*放大1.1倍*/
        }
        50%{
            transform: scale(1);
        }
        75%{
            transform: scale(1.1);
        }

    }

    @-webkit-keyframes mymove 
    {
        0%{
            transform: scale(1);  /*开始为原始大小*/
        }
        25%{
            transform: scale(1.1); /*放大1.1倍*/
        }
        50%{
            transform: scale(1);
        }
        75%{
            transform: scale(1.1);
        }
    }
    .media-rush-btn{
        position: absolute;
        width: 151px;
        height: 44px;
        top: 45px;
        right: 38px;
        animation:mymove 1s infinite;
        -webkit-animation:mymove 1s infinite; /*Safari and Chrome*/
        animation-direction:alternate;/*轮流反向播放动画。*/
        animation-timing-function: ease-in-out; /*动画的速度曲线*/
        /* Safari 和 Chrome */
        -webkit-animation:mymove 1s infinite;
        -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
        -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
    }
    
}

input::-webkit-input-placeholder { 
/* WebKit browsers */ 
  color: rgba(255, 255, 255, .5); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
  color: rgba(255, 255, 255, .5); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
  color: rgba(255, 255, 255, .5); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
  color: rgba(255, 255, 255, .5); 
}
.rush-main{
    background-color: #ffffff;
    text-align: center;
    // padding-bottom: 128px;
    img{
        width: 100%;
        max-width: 750px;
    }
    .pb {
        padding-bottom: 120px;
    }
    .rush-bg{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/img2.png') no-repeat center;
        background-size: 100% 100%;
        padding:171px 30px 52px;
    }
    .rush-bg-new{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-2.png') no-repeat center;
        background-size: 100% 100%;
        padding:101px 30px 72px;
    }
    .rush-bg2{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-8.png') no-repeat center;
        background-size: 100% 100%;
        padding:221px 30px 72px;
    }
    .rush-form{
        padding: 0px 20px 52px;
        border-radius:16px;
        p{
            font-size:19px;
            color:#ffffff;
            line-height:31px;
            width: 590px;
            margin:40px auto 0;
            text-align:left;
        }
        .title{
            font-size:28px;
            color:#333333;
            line-height:1;
            margin-bottom:20px;
            text-align:left;
            font-weight:bold;
        }
        .label{
            text-align:left;
            font-size:20px;
            color:#333333;
            margin-bottom:45px;
            display:flex;
            align-items:center;
            img{
                width:64px;
                height:28px;
                margin-right:10px;
            }
        }
        h5{
            font-size: 20px;
            color: rgba(255, 255, 255, .8);
            line-height:1;
            margin-bottom: 20px;
            text-align: left;
            padding-left: 49px;
            span.c6{
                color:#C6C6C6;
            }
            span.red{
                color:#FF0000;
            }
        }
        input{
            width: 540px;
            height: 83px;
            line-height: 83px;
            border:2px solid rgba(255, 255, 255, .6);
            background-color: rgba(255, 255, 255, .3);
            margin-bottom: 21px;
            padding-left: 20px;
            color: #ffffff;
            box-sizing: border-box;
            border-radius: 47px;
            font-size: 26px;
        }
        input.on{
            border:2px solid #FF0000;
        }
        input.on::-webkit-input-placeholder { 
            /* WebKit browsers */ 
            color: #FF0000; 
        } 
        input.on:-moz-placeholder { 
            /* Mozilla Firefox 4 to 18 */ 
            color: #FF0000; 
        } 
        input.on::-moz-placeholder { 
            /* Mozilla Firefox 19+ */ 
            color: #FF0000; 
        } 
        input.on:-ms-input-placeholder { 
            /* Internet Explorer 10+ */ 
            color: #FF0000; 
        }
        input:focus{
            border:2px solid rgba(255, 255, 255, .5);
            background-color: rgba(255, 255, 255, .5);
        }
        .xy{
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: rgba(255, 255, 255, .8);
            font-weight:bold;
            margin-bottom: 34px;
            padding-left: 49px;
            span{
                color: rgba(255, 196, 34, .81);
            }
            img{
                width: 24px;
                height: 24px;
                margin-right: 30px;
                background-color: rgba(255, 255, 255, 1);
            }
        }
        .subBtn{
            display: block;
            width: 570px;
            line-height: 83px;
            color: #ffffff;
            background: linear-gradient(90deg, #FC9426, #FFC622);
            border-radius: 47px;
            margin: 0 auto;
            font-size: 34px;
        }
    }
}
.qr-code{
    width:750px;
    height:937px;
    background: url('https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/qr-bg.png') no-repeat center;
    background-size: 100% 100%;
    padding:160px 94px 357px;
    .title{
        display:flex;
        font-size:46px;
        color:#FF8D1B;
        text-align:center;
        align-items: center;
        justify-content: center;
        line-height:1;
        margin-bottom:60px;
        span{
            margin:0 18px;
        }
        img{
            width:43px;
            height:16px;
        }
    }
    .p{
        font-size:30px;
        color:#061C2A;
        line-height:1;
        margin-bottom:40px;
        text-align:left;
        padding-left:17px;
        display: flex;
        align-items: baseline;
        img{
            width:18px;
            height:20px;
            margin-right:15px;
        }
    }
    .p.on{
        margin-bottom:50px;
    }
    .line{
        width:564px;
        height:5px;
        margin:0px auto 30px;
    }
    p{
        font-size:24px;
        color:#061C2A;
        line-height:1;
        margin-bottom:10px;
    }
    h5{
        font-size:28px;
        color:#2896D2;
        line-height:1;
    }
    .qr{
        width:230px;
        height:230px;
        margin-top:20px;
    }
}
</style>
<style lang="scss">
.qr-code-pop{
    background:transparent;
}
</style>